import {
  AccountIcon,
  AddIcon,
  DashboardIcon,
  FolderIcon,
  InstitutionIcon,
  StaffIcon,
  FileTertiaryIcon,
  DocumentIcon,
} from "../../assets/images/svgs";
import { FaRocketchat } from "react-icons/fa";

export const STUDENT_NAVIGATION = {
  icon: <AddIcon />,
  buttonText: "Add Project",
  hasActionItem: true,
  navItems: [
    { icon: <DashboardIcon />, text: "Home", url: "home" },
    { icon: <FolderIcon />, text: "Documents", url: "document-processing" },
    { icon: <StaffIcon />, text: "Secretariat", url: "secretariat" },
    { icon: <FileTertiaryIcon />, text: "Community", url: "communities" },
    { icon: <InstitutionIcon />, text: "Events", url: "events" },
    { icon: <DocumentIcon />, text: "Faqs", url: "faq-session" },
    { icon: <FaRocketchat />, text: "Messages", url: "messages" },
    { icon: <AccountIcon />, text: "Account", url: "profile" },
  ],
};

export const SYSTEM_ADMIN_NAVIGATION = {
  icon: <AddIcon />,
  buttonText: "Invite Admin",
  navItems: [
    { icon: <DashboardIcon />, text: "Home", url: "home" },
    {
      icon: <FolderIcon />,
      text: "Documents",
      url: "document-processing",
    },
    {
      icon: <StaffIcon />,
      text: "Students",
      url: "members",
    },
    {
      icon: <InstitutionIcon />,
      text: "Event",
      url: "events",
    },
    {
      icon: <FileTertiaryIcon />,
      text: "Career & Job",
      url: "career-jobs",
    },
    { icon: <AccountIcon />, text: "Account", url: "profile" },
  ],
};

export const SUPER_ADMIN_NAVIGATION = {
  icon: <AddIcon />,
  buttonText: "Invite Admin",
  navItems: [
    { icon: <DashboardIcon />, text: "Home", url: "home" },
    {
      icon: <FolderIcon />,
      text: "Documents",
      url: "document-processing",
    },
    {
      icon: <StaffIcon />,
      text: "Students",
      url: "members",
    },
    {
      icon: <InstitutionIcon />,
      text: "Event",
      url: "events",
    },
    {
      icon: <FileTertiaryIcon />,
      text: "Career & Job",
      url: "career-jobs",
    },
    { icon: <AccountIcon />, text: "Account", url: "profile" },
  ],
};
